import { CoreMenu } from "@core/types";
import { EntityTyp } from "../util/enums/entity-typ.enum";

export const menu: CoreMenu[] = [
  {
    id: "home",
    title: "Startseite",
    type: "item",
    icon: "bi-house",
    url: "home",
    aufHandyAnzeigen: true,
  },
  {
    id: "reports",
    title: "Berichte",
    type: "item",
    icon: "bi-file-earmark-text",
    url: "reports",
    aufHandyAnzeigen: true,
  },
  {
    id: "clients",
    title: "Klient:innen",
    type: "item",
    icon: "bi-people",
    url: "clients",
    aufHandyAnzeigen: true,
  },
  {
    id: "admin",
    title: "Leitung",
    type: "section",
    aufHandyAnzeigen: true,
    children: [
      {
        id: "housing",
        title: "Wohnungen",
        type: "item",
        icon: "bi-building",
        url: "housing",
        aufHandyAnzeigen: true,
        permission: EntityTyp.Housing,
      },
      {
        id: "employees",
        title: "Betreuer:innen",
        type: "item",
        icon: "bi-person-vcard",
        url: "employees",
        aufHandyAnzeigen: true,
        permission: EntityTyp.Employee,
      },
      {
        id: "users",
        title: "Benutzer",
        type: "item",
        icon: "bi-pc-display-horizontal",
        url: "users",
        aufHandyAnzeigen: true,
        permission: EntityTyp.User,
      },
      {
        id: "offices",
        title: "Standorte",
        type: "item",
        icon: "bi-buildings",
        url: "offices",
        aufHandyAnzeigen: true,
        permission: EntityTyp.Office,
      },
    ],
  },
];
